import { render, staticRenderFns } from "./specials.home.vue?vue&type=template&id=85f809c8&scoped=true&"
import script from "./specials.home.vue?vue&type=script&lang=js&"
export * from "./specials.home.vue?vue&type=script&lang=js&"
import style0 from "./specials.home.vue?vue&type=style&index=0&id=85f809c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f809c8",
  null
  
)

export default component.exports